import { Children, ReactElement, useState } from 'react'
// Material
import { MenuList, Dialog, CircularProgress, ListItemIcon } from '@mui/material'
import { styled } from '@mui/material/styles'
import { closeCurrentModal } from 'weblite-web-modal-viewer'

const StyledMenuList = styled(MenuList)`
  padding: 5px 0;
`

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    width: 100%;
    border-radius: 5px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);

    max-width: 340px;
  }
`

const StyledListItemIcon = styled(ListItemIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  '&.MuiListItemIcon-root': {
    minWidth: 'unset !important',
  },
  marginLeft: '25px',
}))

interface Props {
  children:
    | ReactElement
    | (ReactElement | null | undefined)[]
    | null
    | undefined
  open: boolean
}

export function PopupMenuList({ open, children }: Props) {
  const [itemsDisabled, setItemsDisabled] = useState<boolean>(false)
  const [loadingItemIndex, setLoadingItemIndex] = useState<number>(-1)
  return (
    <StyledDialog open={open} onClose={closeCurrentModal}>
      <StyledMenuList>
        {Children.map(children, (menuItem, menuItemIndex) => {
          const { onClick, children: menuItemChildren, ...menuItemProps } =
            menuItem?.props || {}

          const modifiedOnClick = () => {
            if (itemsDisabled) return

            setItemsDisabled(true)
            setLoadingItemIndex(menuItemIndex)
            onClick?.()
          }

          return menuItem ? (
            // TODO: CHECK THIS KEY TO BE UNIQUE
            <menuItem.type
              {...menuItemProps}
              key={menuItem.props.text}
              onClick={modifiedOnClick}
              disabled={itemsDisabled}
            >
              <StyledListItemIcon>
                {menuItemIndex === loadingItemIndex ? (
                  <CircularProgress color="inherit" size={24} />
                ) : (
                  menuItemChildren
                )}
              </StyledListItemIcon>
            </menuItem.type>
          ) : null
        })}
      </StyledMenuList>
    </StyledDialog>
  )
}
